import { Box, Image, useColorModeValue } from '@chakra-ui/react';

/**
 * BanditIcon - Versatile mascot component supporting themed masks and original assets.
 */
export const BanditIcon = ({ boxSize = 12, variant = 'original', ...props }: any) => {
    const isDarkMode = useColorModeValue(false, true);
    const brandRed = 'var(--chakra-colors-brand-500)';
    const lightGrey = 'var(--chakra-colors-gray-300)';

    // Choose mask based on variant
    const getMaskUrl = () => {
        if (variant === 'red') return '/assets/bandit-ai-red.png';
        if (variant === 'default') return '/assets/bandit-default-logo.png';
        return '/assets/bandit-ai.png';
    };

    // For the 'default' variant in light mode, we show the full color image.
    // In dark mode (or for other mask variants), we use the mask approach.
    if (variant === 'default' && !isDarkMode) {
        return (
            <Box boxSize={boxSize} {...props}>
                <Image
                    src="/assets/bandit-default-logo.png"
                    alt="BidBandit Logo"
                    objectFit="contain"
                    w="full"
                    h="full"
                />
            </Box>
        );
    }

    const maskUrl = getMaskUrl();
    const iconBg = variant === 'default' ? lightGrey : brandRed;

    return (
        <Box
            boxSize={boxSize}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            bg={iconBg}
            sx={{
                maskImage: `url(${maskUrl})`,
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
                WebkitMaskImage: `url(${maskUrl})`,
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
            }}
            {...props}
        />
    );
};
